module.exports = __webpack_public_path__ + "static/Embajada-b6c04d10aefcd5de690592649be437e5.jpg";